export const PRICES_ADDRESS_UNAVAILABLE_PARAM = "adres_niedostepny";

export const PRICES_ADDRESS_UNAVAILABLE_MESSAGE =
    "Nie udało się wyświetlić cen dla tego adresu - w rejestrze jest za mało transakcji, żeby pokazać statystyki.";
export const PRICES_ADDRESS_UNAVAILABLE_PARAM = "adres_niedostepny";

export const PRICES_ADDRESS_UNAVAILABLE_MESSAGE =
    "Nie udało się wyświetlić cen dla tego adresu - w rejestrze jest za mało transakcji, żeby pokazać statystyki.";
